import { render, staticRenderFns } from "./InformativeItem.vue?vue&type=template&id=00da808b&scoped=true&"
import script from "./InformativeItem.vue?vue&type=script&lang=js&"
export * from "./InformativeItem.vue?vue&type=script&lang=js&"
import style0 from "./InformativeItem.vue?vue&type=style&index=0&id=00da808b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00da808b",
  null
  
)

export default component.exports